import {Action} from "@ngrx/store";

export const SHOW_NODE = "[ROLE] SHOW";
export const HIDE_NODE = "[ROLE] HIDE";

export class ShowNodeVisible implements Action {
    readonly type = SHOW_NODE;
    constructor(public payload){
    }
}

export class HideNodeVisible implements Action {
    readonly type = HIDE_NODE;
    constructor(public payload){
    }
}

export type BpmnAction = ShowNodeVisible | HideNodeVisible ;